import { registerPlugin } from '@capacitor/core';
const CapacitorKakao = registerPlugin('CapacitorKakao', {
    web: () => import('./web').then(m => new m.CapacitorKakaoWeb()),
});
export * from './definitions';
export { CapacitorKakao };
//# sourceMappingURL=index.js.map